<template>
  <va-modal
    :value="isOpen"
    size="large"
    id="appointmentAnamnesisModal"
    ref="appointmentAnamnesisModal"
    @cancel="onCancel"
    :hideDefaultActions="true"
    >

    <div slot="header">
      <span class="modal-title">{{ $t('evocall.appointment.details') }}</span>
    </div>

    <section v-if="isLoading" class="text-center py-5">
      <span class="is-bold">{{$t('loading.message')}}</span>
    </section>

    <section v-else-if="person && appointment" class="p-3">

      <PersonShortInfo
        v-if="appointment.person"
        class="mb-5"
        :person="appointment.person"
        :serviceSlug="serviceSlug"
      />

      <AppointmentShortInfo
        v-if="appointment"
        class="mb-5"
        :appointment="appointment"
        :serviceSlug="serviceSlug"
      />

      <section>
        <h6 class="is-bold">
          {{$t('clinical.people.clinical_questionnaire')}}
        </h6>

        <div class="p-3">

          <ShowClinicalQuestionnaire
            :value="person.clinical_questionnaires[0]"
          >
          </ShowClinicalQuestionnaire>

          <ShowLifeStyle
            :value="person.life_styles[0]"
          >
          </ShowLifeStyle>

          <ShowOtoscopy
            :value="person.otoscopies[0]"
          >
          </ShowOtoscopy>

          <ShowImpedance
            :value="person.impedances[0]"
          >
          </ShowImpedance>

          <ShowTonalAudiometry
            :value="person.tonal_audiometries[0]"
          >
          </ShowTonalAudiometry>

          <ShowVocalAudiometry
            :value="person.vocal_audiometries[0]"
          >
          </ShowVocalAudiometry>

          <ShowHearingDevices
            :title="$t('clinical.people.anamnesis.sale_data')"
            :value="appointment.hearing_devices"
          >
          </ShowHearingDevices>

        </div>

      </section>
    </section>

  </va-modal>
</template>

<script>
import ShowOtoscopy from '@/components/clinical/people/Anamnesis/ShowOtoscopy'
import ShowLifeStyle from '@/components/clinical/people/Anamnesis/ShowLifeStyle'
import PersonShortInfo from '@/components/clinical/people/PersonDetails/PersonShortInfo'
import ShowHearingDevices from '@/components/clinical/people/Anamnesis/ShowHearingDevices'
import AppointmentShortInfo from '@/components/clinical/appointments/AppointmentShortInfo'
import ShowTonalAudiometry from '@/components/clinical/people/Anamnesis/ShowTonalAudiometry'
import ShowVocalAudiometry from '@/components/clinical/people/Anamnesis/ShowVocalAudiometry'
import ShowClinicalQuestionnaire from '@/components/clinical/people/Anamnesis/ShowClinicalQuestionnaire'
import { PersonService } from '@/api/AuthClinicalService'
import ShowImpedance from "@/components/clinical/people/Anamnesis/ShowImpedance";

export default {
  props: {
    appointment: {
      type: Object,
      required: true
    },
    serviceSlug: {
      type: String,
      required: true
    },
    request: {
      type: Object,
      required: true
    },
    loadedPerson: {
      type: Object,
      required: false
    }
  },
  components: {
    ShowImpedance,
    ShowOtoscopy,
    ShowLifeStyle,
    PersonShortInfo,
    ShowHearingDevices,
    ShowTonalAudiometry,
    ShowVocalAudiometry,
    AppointmentShortInfo,
    ShowClinicalQuestionnaire
  },
  data: function () {
    return {
      isOpen: false,
      person: null,
      isLoading: false,
    }
  },
  mounted: function () {
    this.isOpen = true
    if (this.loadedPerson) {
      this.person = this.loadedPerson
    } else {
      this.isLoading = true
      this.loadPerson(this.appointment.person.id).then(person => {
        this.person = person
        this.isLoading = false
      })
    }
  },
  computed: {
    authClinicalService: function () {
      return this.request ? this.$store.state.services.find(s => s.id === this.request.service_id) : null
    },
  },
  methods: {
    loadPerson: function (personId) {
      if (this.authClinicalService) {
        return new Promise((resolve, reject) => {
          PersonService.get(this.authClinicalService.url, personId)
            .then(person => {
              resolve(person)
            })
            .catch(error => reject(error))
        })
      }
    },
    onCancel: function () {
      this.isOpen = false
      setTimeout(() => {
        this.$emit('modalClosed')
      }, 500)
    }
  }
}
</script>
